export default "__VITE_ASSET__4eb73388__"